var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-text-field", {
    ref: "textField",
    style: _vm.styleProp,
    attrs: {
      id: _vm.id,
      color: _vm.PrimaryColor,
      autocomplete: "null",
      "hide-details": _vm.hideDetails,
      "hide-spin-buttons": "",
      loading: _vm.loading,
      prefix: _vm.prefix,
      disabled: _vm.disabled,
      value: _vm.vmodel,
      counter: _vm.counter,
      hint: _vm.hint,
      backgroundColor: _vm.backgroundColor,
      outlined: "",
      label: _vm.title,
      rules: _vm.rulesInput,
      type: _vm.type,
      maxlength: _vm.maxlength,
    },
    on: {
      keydown: _vm.Onkeydown,
      keyup: function ($event) {
        if (
          !$event.type.indexOf("key") &&
          _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
        )
          return null
        return _vm.onEnter.apply(null, arguments)
      },
      input: _vm.handleInput,
      wheel: function ($event) {
        return $event.target.blur()
      },
      blur: _vm.validateField,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }